"use strict";

import {
    addPendingActions,
    removePendingActions,
    hideAjaxSuccess,
} from "../_actions";

export const loadingSpinnerMiddleware = (store) => (next) => (action) => {
    if (typeof action.type != "undefined") {
        
        let isRequest = action.type.includes("REQUEST");
        let isComplete = action.type.includes("COMPLETE");
        let isError = action.type.includes("ERROR");

        if (isRequest) {
            let loadingShow = true;

            if (typeof action.payload != "undefined") {
                if (typeof action.payload.loadingHide != "undefined") {
                    
                    loadingShow = false;
                    delete action.payload.loadingHide;
                }
            }
            if (loadingShow) {
                store.dispatch(addPendingActions(action.type));
                store.dispatch(hideAjaxSuccess());
            }
        }

        if (isComplete) {
            let actionType = action.type.split("COMPLETE")[0] + "REQUEST";
            store.dispatch(removePendingActions(actionType));
        }

        if (isError) {
            let actionType = action.type.split("ERROR")[0] + "REQUEST";
            store.dispatch(removePendingActions(actionType));
        }
    }

    next(action);
};
